
export class GetArticleDictionary {
  static readonly type = 'GetArticleDictionary';
    constructor() { }
  }
